require('./hireCardAtHomeAbroadSuccess.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getLastNChars } = require('utilities/stringHelper');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const WebappRender = require('components/conditionalRender/webappRender')
const HireSuccessStepCardImage = require('components/cards/hireSuccessStepCardImage/hireSuccessStepCardImage');
const { catalogue, analyticsId } = require('../analytics/hireCardAtHomeAbroadAnalytics');

class HireCardAtHomeAbroadSuccess extends React.Component {

    buildSummary() {
        const {
            immAccount,
            immHireCardNameSelector,
        } = this.props;

        const accountIban = getLastNChars(immAccount.get('iban'));

        return (
            <div className="row hire-card-at-home-abroad-success__summary">
                <div className="col-xs-6">
                    <FormattedText
                        className="col-xs-12 hire-card-at-home-abroad-success__summary-title"
                        value="hireCardAtHomeAbroad-summarySelectedName"
                    />
                    <div className="col-xs-12 hire-card-at-home-abroad-success__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                </div>
                <div className="col-xs-6">
                    <FormattedText
                        className="col-xs-12 hire-card-at-home-abroad-success__summary-title"
                        value="hireCardAtHomeAbroad-summarySelectedAccount"
                    />
                    <div className="col-xs-12 hire-card-at-home-abroad-success__summary-value">
                        {`${immAccount.get('alias')} ${accountIban}`}
                    </div>
                </div>
            </div>
        );
    }

    buildMessage() {
        const { immProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);
        const text = !!email ? 'hireCardAtHomeAbroad-successWarningTextSentByEmail' : 'hireCardAtHomeAbroad-successWarningTextUpdateEmail';
        const injectedString = [
            ...(!!email ? [email] : [])
        ];

        return (
            <div className="hire-card-at-home-abroad-success__message">
                <OKMessage type="informative">
                    <FormattedText value={text} injectedStrings={injectedString} />
                </OKMessage>
            </div>
        );
    }

    render() {
        const {
            immHireCardImageSelector,
            immProfile,
            immShippingAddress,
            processDetail
        } = this.props;
        let content;

        if (immProfile.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const messageSection = this.buildMessage();
            const summarySection = this.buildSummary();
            const address = PersonalDataHelper.getHireFormattedAddress(immShippingAddress);
            const selectedImageId = immHireCardImageSelector.get('selectedImageId');
            const immImageData = immHireCardImageSelector.getIn(['imagesById', selectedImageId]);
            const goBackButton = {
                label: (
                    <FormattedText
                        format="uppercase"
                        value="hireCardAtHomeAbroad-successBackButtonText"
                    />
                ),
                url: '/myprofile/cards'
            };

            content = (
                <WizardSuccess
                    mainButton={goBackButton}
                    processDetail={processDetail}
                    successMessage={formatText('hireCardAtHomeAbroad-successTitle')}
                    tealium={catalogue[analyticsId.AT_HOME_ABROAD_CARD_WIZARD_SUCCESS]({ productName: processDetail })}
                    isSecondVersion
                >
                    <article className="hire-card-at-home-abroad-success">
                        <div className="row">
                            <div className="col-xs-4">
                                <HireSuccessStepCardImage
                                    className="hire-card-at-home-abroad-success__card-image"
                                    immImageData={immImageData}
                                />
                            </div>
                            <div className="col-xs-8 hire-card-at-home-abroad-success__text">
                                <FormattedText value="hireCardAtHomeAbroad-successAddressText1" />
                                <div className="hire-card-at-home-abroad-success__address">
                                    <i className="hire-card-at-home-abroad-success__address-icon icon icon-s-locacion" />
                                    {address}
                                </div>
                                <FormattedText value="hireCardAtHomeAbroad-successAddressText2" />
                                <div className="hire-card-at-home-abroad-success__phone">
                                    <i className="hire-card-at-home-abroad-success__phone-icon icon icon-s-llamar" />
                                    <FormattedText value="hireCardAtHomeAbroad-phoneNumberClients" />
                                </div>
                            </div>
                        </div>
                        {summarySection}
                        <WebappRender>
                            {messageSection}
                        </WebappRender>
                    </article>
                </WizardSuccess>
            );
        }
        return content
    }
}

HireCardAtHomeAbroadSuccess.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardAtHomeAbroad: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    processDetail: PropTypes.string
};

module.exports = HireCardAtHomeAbroadSuccess;
